import { jsx } from "react/jsx-runtime";
import "../ExternalLink.js";
import { ExternalLink } from "../ExternalLink/ExternalLink.js";
const LearnMoreLink = ({ href, "aria-label": ariaLabel, text = "Learn more" }) => /* @__PURE__ */ jsx(ExternalLink, { text, href, "aria-label": ariaLabel, iconProps: { iconName: "OpenInNewWindow" } });
export {
  LearnMoreLink
};
//# sourceMappingURL=LearnMoreLink.js.map
